module.exports = __webpack_public_path__ + "img/open-folder.b9d2e05c.svg";